import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { EYesNo } from '../../../../../shared/models/types.enum';
import { FormUtils } from '../../../../../shared/helpers/formUtils';

@Component({
  selector: 'aggression',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './aggression.component.html',
  styleUrl: './aggression.component.css'
})
export class AggressionComponent implements OnInit, OnChanges {

  @Input() teacherStaffInterviewData: any;
  @Output() onSaveSection7 = new EventEmitter<any>();

  yesNo = EYesNo;
  aggressionForm: FormGroup = new FormGroup([]);
  radioQuestions = [
    {
      id: 'student_aggression',
      questionText: "Has the student expressed anger or aggression? *",
      formControlName: 'student_aggression',
      infoFormControlName: 'student_aggression_information'
    },
    {
      id: 'grudge',
      questionText: "Does this student seem to hold a grudge or seem resentful? *",
      formControlName: 'grudge',
      infoFormControlName: 'grudge_information'
    }
  ];

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private formUtils: FormUtils
  ) {}

  ngOnInit() {
    this.initializeForm();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['teacherStaffInterviewData'] && this.teacherStaffInterviewData) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    const group: any = {};
    
    this.radioQuestions.forEach(question => {
      const defaultValue = this.teacherStaffInterviewData && this.teacherStaffInterviewData[question.formControlName] !== undefined
                           ? this.teacherStaffInterviewData[question.formControlName]
                           : this.yesNo.No;  

      group[question.formControlName] = new FormControl(
          String(defaultValue), 
          Validators.required
      );
      group[question.infoFormControlName] = new FormControl({ value: this.teacherStaffInterviewData?.[question.infoFormControlName] || '', disabled: this.teacherStaffInterviewData?.[question.infoFormControlName] ? false : true });
    });

    this.aggressionForm = new FormGroup(group);
    this.setupFormChangeHandlers();
  }

  setupFormChangeHandlers() {
    this.radioQuestions.forEach(question => {
      const control = this.aggressionForm.get(question.formControlName);
      if (control) {
        control.valueChanges.subscribe(value => {
          const infoControl = this.aggressionForm.get(question.infoFormControlName);
          if (infoControl) {
            this.formUtils.handleConditionChange(infoControl, value === this.yesNo.Yes);
          }
        });
      }
    });
  }  

  saveAggression(): void {
    if (this.aggressionForm.valid) {
      this.onSaveSection7.emit(this.aggressionForm.value);
    }
  }

}
